const checkIsObject = (value) => {
    return !!(value && typeof value === 'object' && !Array.isArray(value));
};
const encodeUriVal = (val) => {
    // Keep commas for string with comma separated values
    // return encodeURIComponent(val).replace(/%2C/g, ",");
    return encodeURIComponent(val);
};
const encodeObject = (val = {}) => {
    const encodedObj = Object.assign({}, val);
    const entries = Object.entries(encodedObj);
    for (let i = 0; i < entries.length; i += 1) {
        const [objectKey, objectValue] = entries[i];
        if (checkIsObject(objectValue)) {
            encodedObj[objectKey] = encodeObject(objectValue);
        }
        else if (Array.isArray(objectValue)) {
            encodedObj[objectKey] = objectValue.map((value) => {
                return checkIsObject(value)
                    ? encodeObject(value)
                    : encodeUriVal(value);
            });
        }
        else {
            encodedObj[objectKey] = encodeUriVal(objectValue);
        }
    }
    return encodedObj;
};
export const uriEncode = (value) => {
    if (checkIsObject(value)) {
        return encodeObject(value);
    }
    if (Array.isArray(value)) {
        return value.map((item) => encodeObject(item));
    }
    return encodeUriVal(value);
};
